<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- fuente baja form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código Fuente Baja *"
          label-for="codigo"
          description="Escriba el código"
        >
          <b-form-input
            id="codigo"
            v-model="fuenteBaja.id_fuente"
            type="text"
            required
            placeholder="Código Fuente Baja"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal Fuente Baja *"
          label-for="literal"
          description="Escriba el literal"
        >
          <b-form-input
            id="literal"
            v-model="fuenteBaja.descripcion"
            type="text"
            required
            placeholder="Literal Fuente Baja"
          ></b-form-input>
        </b-form-group>
        <!-- literal comercial -->
        <b-form-group
          label="Literal Comercial Fuente Baja *"
          label-for="literal"
          description="Escriba el literal comercial"
        >
          <b-form-input
            id="literal_comercial"
            v-model="fuenteBaja.descripcion_comercial"
            type="text"
            required
            placeholder="Literal Comercial Fuente Baja"
          ></b-form-input>
        </b-form-group>
        <!-- prioridad -->
        <b-form-group
          label="Prioridad Fuente Baja *"
          label-for="literal"
          description="Escriba la prioridad"
        >
          <b-form-input
            id="prioridad"
            v-model="fuenteBaja.prioridad"
            type="text"
            required
            placeholder="Prioridad Fuente Baja"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_FUENTE_BAJA,
  EDIT_FUENTE_BAJA
} from "@/core/services/store/fuenteBaja.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "fuente-baja-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: true,
      fuenteBaja: {
        id_fuente: null,
        descripcion: "",
        descripcion_comercial: "",
        prioridad: 12
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar fuente baja" : "Nueva fuente baja";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.loading = true;
      const resp = await ApiService.get(
        `dic_fuente_bajas?id_fuente=${this.$route.params.id}`
      );
      this.fuenteBaja = resp.data.result[0];
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.$router.push("/lists/fuente-baja");
    },
    onSubmit() {
      if (this.isEdit) {
        this.$store.dispatch(EDIT_FUENTE_BAJA, this.fuenteBaja).then(() => {
          this.cancel();
        });
      } else {
        this.$store.dispatch(ADD_FUENTE_BAJA, this.fuenteBaja).then(() => {
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
